import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";

export const GET_COMPANIES = "get_companies";

@Component
export default class CompaniesMixin extends Vue {
  index(type: string) {
    const path = `${API_ENDPOINT}/special_initiatives/companies.json?filter[company_type]=${type}`;
    return this.$store.dispatch("http/request", {
      tag: GET_COMPANIES,
      url: path,
      method: "GET",
    });
  }
}
